module.exports = __webpack_public_path__ + "img/prize-phone.2d70234d.png";